module.exports = __webpack_public_path__ + "img/explain.34949510.svg";